















import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

import ModuleList from '../../modules/components/List.vue'

@Component({
  components: {
    ModuleList
  }
})
export default class ModulesTile extends Vue {
  @Prop({ default: () => [] })
  modules!: any[]

  @Prop({ required: true})
  courseId!: number

  @Prop({ required: true})
  courseCompleted!: boolean

  @Prop({ required: true})
  isEnrolled!: boolean

  @Prop({ required: true})
  adminView!: boolean
}
